import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {AddClientStoreForm} from "./AddClientStoreForm";

export class AddClientStoreModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulSubmit = this.afterSuccessfulSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    afterSuccessfulSubmit(newClientAdAccountId) {
        this.toggle();
        this.props.afterSuccessfulSubmit(newClientAdAccountId);
    }

    renderHeaderTitle() {
        if(this.props.clientId === undefined)
            return "Vincular Tienda";

        return "Agregar nueva Tienda";
    }

    render() {
        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className} backdrop="static">
                <ModalHeader toggle={this.toggle}>{this.renderHeaderTitle()}</ModalHeader>
                <AddClientStoreForm afterSuccessfulSubmit={this.afterSuccessfulSubmit}
                                        clientId={this.props.clientId}
                                        platform={this.props.platform}
                                        storeId={this.props.storeId}
                                        clientName={this.props.clientName}/>
            </Modal>
        );
    }
}
